module.exports = __webpack_public_path__ + "img/avatar-9.10f9b68d.png";